import React, { useState } from 'react';
import { Modal, StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

const CustomModal = (props) => {
  const { modalVisible, setModalVisible, Content } = props;
  const [preventClose, setPreventClose] = useState(false);
  
  const preventModalFromClosing = () => {
    if(preventClose){
      return true;
    }
    setModalVisible(!modalVisible)
  }
  return (
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => preventModalFromClosing}>
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Content modalVisible={modalVisible} setModalVisible={setModalVisible} setPreventClose={setPreventClose} {...props}/>
          </View>
        </View>
        <LinearGradient
          colors={['#000', '#000','#000' ]}
          style={styles.background}
        />
      </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
    width: "100%",
  },
  modalView: {
    width: "80%",
    margin: 10,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: "100%",
    opacity: 0.25,
    zIndex: -1,
  },
});

export default CustomModal;